import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskLines = ({ lines, className = "", lineClass = "", delay = 0.15, inView = false }) => {
  const trigger = inView
    ? { whileInView: "show", viewport: { once: true, amount: 0.1 } }
    : { animate: "show" };
  return (
    <motion.span className={`block ${className}`} initial="hidden" {...trigger}>
      {lines.map((l, i) => (
        <span key={i} className="block overflow-hidden pb-[0.06em]">
          <motion.span
            className={`block ${typeof l === "object" && l.cls ? l.cls : lineClass}`}
            variants={{
              hidden: { y: "110%" },
              show: { y: "0%", transition: { duration: 1.1, delay: delay + i * 0.12, ease: EASE } },
            }}
          >
            {typeof l === "object" ? l.text : l}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
};
